module.exports = __webpack_public_path__ + "img/fig21.ad307935.jpg";